import { render, staticRenderFns } from "./ModalPdf.vue?vue&type=template&id=ca56f89e"
import script from "./ModalPdf.vue?vue&type=script&lang=ts"
export * from "./ModalPdf.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports